import React from 'react';
import { locale } from './locale';
export const LocaleContext = React.createContext({ locale: locale.en });
//# sourceMappingURL=LocaleContext.js.map